import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DataService } from '../../../services/data.service';
import { TranslateService } from '@ngx-translate/core';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { SpinnerService } from 'shared-components';

@Component({
    selector: 'app-avisos-designaciones',
    templateUrl: './avisos-designaciones.component.html'
})
export class AvisosDesignacionesComponent implements OnInit, OnDestroy {

    public cargaCompleta = false;
    // Este número se deberá devolver desde back mediante un servicio al acceder a la pantalla
    public totalAvisos = 15;

    public expedicionCero = [];
    public datosExpedicionCero = [];

    public expedicionDesignados = [];
    public datosExpedicionDesignados = [];

    public designadosAforo = [];
    public datosDesignadosAforo = [];

    public designacionesDeshabilitadas = [];
    public datosDesignacionesDeshabilitadas = [];

    public designacionesFinalizadas = [];
    public datosDesignacionesFinalizadas = [];

    public allDonuts = [];
    public donutsPorPrioridad = [];

    public colors = [
        {
            backgroundColor: ['rgba(22,97,76,255)', 'rgba(22,97,76,0.4)'],
        },
        {
            backgroundColor: ['rgba(251,128,45,255)', 'rgba(251,128,45,0.4)'],
        },
        {
            backgroundColor: ['rgba(193,72,72,255)', 'rgba(193,72,72,0.4)'],
        },
    ];

    public toCloseSpinner = 0;

    public gridModal = false;
    public tituloGrid;

    public showAll = true;

    public dataExpedicionCero;

    public animation;

    @Input() set priority(value: string) {
        if (value === 'ALTA') {
            this.showAll = false;
            this.donutsPorPrioridad = this.allDonuts.filter(donut => donut.colors.backgroundColor[0].toString() === this.colors[2].backgroundColor[0].toString());
        } else if (value === 'MEDIA') {
            this.showAll = false;
            this.donutsPorPrioridad = this.allDonuts.filter(donut => donut.colors.backgroundColor[0].toString() === this.colors[1].backgroundColor[0].toString());
        } else if (value === 'BAJA') {
            this.showAll = false;
            this.donutsPorPrioridad = this.allDonuts.filter(donut => donut.colors.backgroundColor[0].toString() === this.colors[0].backgroundColor[0].toString());
        } else {
            this.showAll = true;
            this.donutsPorPrioridad = [];
        }
    }

    @Input() set startAnimation(value: boolean) {
        this.animation = value;
    }

    @Input() donutsDesignacionesInput;
    @Output() donutsDesignacionesOutput = new EventEmitter<any>();
    @Output() disableFilters = new EventEmitter();
    @Output() numAvisosTotales = new EventEmitter();
    @Output() numAvisos = new EventEmitter();

    constructor(
        private readonly _dataService: DataService,
        private readonly _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService,
        private readonly _translate: TranslateService
    ) { }

    ngOnInit() {
        if (this.donutsDesignacionesInput) {
            this.allDonuts = this.donutsDesignacionesInput;
            this.cargaCompleta = true;
        } else {
            const promises: Promise<any>[] = [];

            promises.push(this.getKgExpedicionCero());

            promises.push(this.getKgExpedicionRespectoDesignados({}, '='));
            promises.push(this.getKgExpedicionRespectoDesignados({ min: null, max: 50 }, '<'));
            promises.push(this.getKgExpedicionRespectoDesignados({ min: 50, max: 75 }, '<'));
            promises.push(this.getKgExpedicionRespectoDesignados({ min: 115, max: 120 }, '>'));
            promises.push(this.getKgExpedicionRespectoDesignados({ min: 120, max: 125 }, '>'));
            promises.push(this.getKgExpedicionRespectoDesignados({ min: 125, max: null }, '>'));

            promises.push(this.getKgDesignadosRespectoAforo({ min: null, max: 90 }, '<'));
            promises.push(this.getKgDesignadosRespectoAforo({ min: 90, max: 99 }, '<'));
            promises.push(this.getKgDesignadosRespectoAforo({ min: 101, max: 110 }, '>'));
            promises.push(this.getKgDesignadosRespectoAforo({ min: 110, max: null }, '>'));

            promises.push(this.getDesignacionesDeshabilitadas());

            promises.push(this.getDesignacionesFinalizadas());

            this.disableFilters.emit(true);
            this.numAvisosTotales.emit(this.totalAvisos);
            Promise.all(promises).then(
                () => {
                    this.agruparInfo();
                    this.disableFilters.emit(false);
                    this.cargaCompleta = true;
                }, (error) => {
                    console.log('Promise rejected with ' + JSON.stringify(error));
                }
            ).catch(e => console.log(e));
        }

        // Descomentar si hay problemas en el redibujado
        // window.onfocus = (e) => {
        //     this.dibujarDonuts();
        // };

    }

    ngOnDestroy() {
        this.donutsDesignacionesOutput.emit(this.allDonuts);
    }

    // private dibujarDonuts() {
    //     this.datosExpedicionCero.forEach(expCero => {
    //         this.expedicionCero[expCero.prioridad] = {
    //             label: 'Kg. Expedición = 0',
    //             subLabel: '(' + expCero.dias + ' ' + 'días)',
    //             descripcion: 'Designaciones de las que no se han consumido kilos de expedición a los'
    //                 + ' ' + expCero.dias + ' ' + 'días de iniciarse la campaña.',
    //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
    //             dataList: [expCero.porcentaje, (100 - expCero.porcentaje).toFixed(2), expCero.numerador + '/' + expCero.denominador],
    //             colors: expCero.color
    //         };
    //     });

    //     this.datosExpedicionDesignados.forEach((expedicion, index) => {
    //         this.expedicionDesignados[index] = {
    //             label: expedicion.label,
    //             subLabel: expedicion.subLabel,
    //             descripcion: expedicion.descripcion,
    //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
    //             dataList: [expedicion.porcentaje,
    //             (100 - expedicion.porcentaje).toFixed(2), expedicion.numerador + '/' + expedicion.denominador],
    //             colors: expedicion.color
    //         };
    //     });

    //     this.datosDesignadosAforo.forEach((designado, index) => {
    //         this.designadosAforo[index] = {
    //             label: designado.label,
    //             subLabel: designado.subLabel,
    //             descripcion: designado.descripcion,
    //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
    //             dataList: [designado.porcentaje,
    //             (100 - designado.porcentaje).toFixed(2), designado.numerador + '/' + designado.denominador],
    //             colors: designado.color
    //         };
    //     });

    //     this.datosDesignacionesDeshabilitadas.forEach((designacion, index) => {
    //         this.designacionesDeshabilitadas[index] = {
    //             label: 'Designaciones deshabilitadas',
    //             subLabel: '',
    //             descripcion: 'Designaciones que han sido deshabilitadas.',
    //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
    //             dataList: [designacion.porcentaje, (100 - designacion.porcentaje).toFixed(2), designacion.numerador + '/' + designacion.denominador],
    //             colors: designacion.color
    //         };
    //     });

    //     this.datosDesignacionesFinalizadas.forEach((designacion, index) => {
    //         this.designacionesFinalizadas[index] = {
    //             label: 'Designaciones finalizadas',
    //             subLabel: '',
    //             descripcion: 'Designaciones que han sido finalizadas.',
    //             labelList: ['Cumplen Condición', 'No Cumplen Condición'],
    //             dataList: [designacion.porcentaje, (100 - designacion.porcentaje).toFixed(2), designacion.numerador + '/' + designacion.denominador],
    //             colors: designacion.color
    //         };
    //     });
    // }

    public getKgExpedicionCero(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._spinnerService.showSpinner();
            if (this.toCloseSpinner === 0) {
                this.toCloseSpinner += 1;
            }
            this._dataService.getKilosExpedicionCeroDesignaciones().toPromise().finally(() => {
                this.checkCloseSpinner();
                this.numAvisos.emit(3);
            }).then((resp) => {
                if (resp) {
                    this.datosExpedicionCero[0] = {
                        dias: 30,
                        porcentaje: resp.graficaCeroKg_30Dias.porcentaje,
                        numerador: resp.graficaCeroKg_30Dias.numerador,
                        denominador: resp.graficaCeroKg_30Dias.denominador,
                        color: this.colors[0],
                        prioridad: resp.graficaCeroKg_30Dias.centralAvisosPrioridadId - 1
                    };

                    this.datosExpedicionCero[1] = {
                        dias: 45,
                        porcentaje: resp.graficaCeroKg_45Dias.porcentaje,
                        numerador: resp.graficaCeroKg_45Dias.numerador,
                        denominador: resp.graficaCeroKg_45Dias.denominador,
                        color: this.colors[1],
                        prioridad: resp.graficaCeroKg_45Dias.centralAvisosPrioridadId - 1
                    };

                    this.datosExpedicionCero[2] = {
                        dias: 60,
                        porcentaje: resp.graficaCeroKg_60Dias.porcentaje,
                        numerador: resp.graficaCeroKg_60Dias.numerador,
                        denominador: resp.graficaCeroKg_60Dias.denominador,
                        color: this.colors[2],
                        prioridad: resp.graficaCeroKg_60Dias.centralAvisosPrioridadId - 1
                    };

                    this.expedicionCero[0] = {
                        label: this._translate.instant('central-avisos.designaciones.expedicionCero.label'),
                        subLabel: this._translate.instant('central-avisos.designaciones.expedicionCero.subLabel30'),
                        descripcion: this._translate.instant('central-avisos.designaciones.expedicionCero.descripcion30'),
                        labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                        dataList: [resp.graficaCeroKg_30Dias.porcentaje,
                        (100 - resp.graficaCeroKg_30Dias.porcentaje).toFixed(2),
                        resp.graficaCeroKg_30Dias.numerador + '/' + resp.graficaCeroKg_30Dias.denominador],
                        colors: this.colors[0]
                    };

                    this.expedicionCero[1] = {
                        label: this._translate.instant('central-avisos.designaciones.expedicionCero.label'),
                        subLabel: this._translate.instant('central-avisos.designaciones.expedicionCero.subLabel45'),
                        descripcion: this._translate.instant('central-avisos.designaciones.expedicionCero.descripcion45'),
                        labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                        dataList: [resp.graficaCeroKg_45Dias.porcentaje,
                        (100 - resp.graficaCeroKg_45Dias.porcentaje).toFixed(2),
                        resp.graficaCeroKg_45Dias.numerador + '/' + resp.graficaCeroKg_45Dias.denominador],
                        colors: this.colors[1]
                    };

                    this.expedicionCero[2] = {
                        label: this._translate.instant('central-avisos.designaciones.expedicionCero.label'),
                        subLabel: this._translate.instant('central-avisos.designaciones.expedicionCero.subLabel60'),
                        descripcion: this._translate.instant('central-avisos.designaciones.expedicionCero.descripcion60'),
                        labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                        dataList: [resp.graficaCeroKg_60Dias.porcentaje,
                        (100 - resp.graficaCeroKg_60Dias.porcentaje).toFixed(2),
                        resp.graficaCeroKg_60Dias.numerador + '/' + resp.graficaCeroKg_60Dias.denominador],
                        colors: this.colors[2]
                    };
                }
                setTimeout(resolve, 1);
            }, (error) => {
              setTimeout(resolve, 1);
            });
        });
    }

    public getKgExpedicionRespectoDesignados(porcentajes, operador): Promise<any> {
        return new Promise((resolve, reject) => {
            let filters;
            if (operador === '=') {
                filters = {
                    operadorIgualdad: true
                };
            } else {
                filters = {
                    porcentajeMin: porcentajes.min ? porcentajes.min : null,
                    porcentajeMax: porcentajes.max ? porcentajes.max : null
                };
            }
            this._spinnerService.showSpinner();
            if (this.toCloseSpinner === 0) {
                this.toCloseSpinner += 1;
            }
            this._dataService.getKilosExpedicionRespectoDesignadosDesignaciones(filters).toPromise().finally(() => {
                this.checkCloseSpinner();
                this.numAvisos.emit(1);
            }).then((resp) => {
                if (resp) {
                    if (operador === '=') {
                        this.datosExpedicionDesignados[0] = {
                            descripcion: this._translate.instant('central-avisos.designaciones.expedicionDesignados.descripcionIgual'),
                            label: this._translate.instant('central-avisos.designaciones.expedicionDesignados.preLabel') + operador
                                    + this._translate.instant('central-avisos.designaciones.expedicionDesignados.postLabel'),
                            subLabel: '',
                            porcentaje: resp.porcentaje,
                            numerador: resp.numerador,
                            denominador: resp.denominador,
                            color: this.colors[resp.centralAvisosPrioridadId - 1],
                            prioridad: resp.centralAvisosPrioridadId - 1
                        };

                        this.expedicionDesignados[0] = {
                            label: this._translate.instant('central-avisos.designaciones.expedicionDesignados.preLabel') + operador
                                    + this._translate.instant('central-avisos.designaciones.expedicionDesignados.postLabel'),
                            subLabel: '',
                            descripcion: this._translate.instant('central-avisos.designaciones.expedicionDesignados.descripcionIgual'),
                            labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                            dataList: [resp.porcentaje, (100 - resp.porcentaje).toFixed(2), resp.numerador + '/' + resp.denominador],
                            colors: this.colors[resp.centralAvisosPrioridadId - 1]
                        };
                    } else if (operador === '<' && !porcentajes.min) {
                        this.datosExpedicionDesignados[1] = {
                            descripcion: this._translate.instant('central-avisos.designaciones.expedicionDesignados.descripcionMenos50'),
                            label: this._translate.instant('central-avisos.designaciones.expedicionDesignados.preLabel') + operador
                                    + this._translate.instant('central-avisos.designaciones.expedicionDesignados.postLabel'),
                            subLabel: '(<50%)',
                            porcentaje: resp.porcentaje,
                            numerador: resp.numerador,
                            denominador: resp.denominador,
                            color: this.colors[resp.centralAvisosPrioridadId - 1],
                            prioridad: resp.centralAvisosPrioridadId - 1
                        };

                        this.expedicionDesignados[1] = {
                            label: this._translate.instant('central-avisos.designaciones.expedicionDesignados.preLabel') + operador
                                    + this._translate.instant('central-avisos.designaciones.expedicionDesignados.postLabel'),
                            subLabel: '(<50%)',
                            descripcion: this._translate.instant('central-avisos.designaciones.expedicionDesignados.descripcionMenos50'),
                            labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                            dataList: [resp.porcentaje, (100 - resp.porcentaje).toFixed(2), resp.numerador + '/' + resp.denominador],
                            colors: this.colors[resp.centralAvisosPrioridadId - 1]
                        };
                    } else if (operador === '<' && porcentajes.max) {
                        this.datosExpedicionDesignados[2] = {
                            descripcion: this._translate.instant('central-avisos.designaciones.expedicionDesignados.descripcion5075'),
                            label: this._translate.instant('central-avisos.designaciones.expedicionDesignados.preLabel') + operador
                                    + this._translate.instant('central-avisos.designaciones.expedicionDesignados.postLabel'),
                            subLabel: '(50%-75%)',
                            porcentaje: resp.porcentaje,
                            numerador: resp.numerador,
                            denominador: resp.denominador,
                            color: this.colors[resp.centralAvisosPrioridadId - 1],
                            prioridad: resp.centralAvisosPrioridadId - 1
                        };

                        this.expedicionDesignados[2] = {
                            label: this._translate.instant('central-avisos.designaciones.expedicionDesignados.preLabel') + operador
                                    + this._translate.instant('central-avisos.designaciones.expedicionDesignados.postLabel'),
                            subLabel: '(50%-75%)',
                            descripcion: this._translate.instant('central-avisos.designaciones.expedicionDesignados.descripcion5075'),
                            labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                            dataList: [resp.porcentaje, (100 - resp.porcentaje).toFixed(2), resp.numerador + '/' + resp.denominador],
                            colors: this.colors[resp.centralAvisosPrioridadId - 1]
                        };
                    } else if (operador === '>' && porcentajes.max === 120) {
                        this.datosExpedicionDesignados[3] = {
                            descripcion: this._translate.instant('central-avisos.designaciones.expedicionDesignados.descripcion1520'),
                            label: this._translate.instant('central-avisos.designaciones.expedicionDesignados.preLabel') + operador
                                    + this._translate.instant('central-avisos.designaciones.expedicionDesignados.postLabel'),
                            subLabel: '(15%-20%)',
                            porcentaje: resp.porcentaje,
                            numerador: resp.numerador,
                            denominador: resp.denominador,
                            color: this.colors[resp.centralAvisosPrioridadId - 1],
                            prioridad: resp.centralAvisosPrioridadId - 1
                        };

                        this.expedicionDesignados[3] = {
                            label: this._translate.instant('central-avisos.designaciones.expedicionDesignados.preLabel') + operador
                                    + this._translate.instant('central-avisos.designaciones.expedicionDesignados.postLabel'),
                            subLabel: '(15%-20%)',
                            descripcion: this._translate.instant('central-avisos.designaciones.expedicionDesignados.descripcion1520'),
                            labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                            dataList: [resp.porcentaje, (100 - resp.porcentaje).toFixed(2), resp.numerador + '/' + resp.denominador],
                            colors: this.colors[resp.centralAvisosPrioridadId - 1]
                        };
                    } else if (operador === '>' && porcentajes.max === 125) {
                        this.datosExpedicionDesignados[4] = {
                            descripcion: this._translate.instant('central-avisos.designaciones.expedicionDesignados.descripcion2025'),
                            label: this._translate.instant('central-avisos.designaciones.expedicionDesignados.preLabel') + operador
                                    + this._translate.instant('central-avisos.designaciones.expedicionDesignados.postLabel'),
                            subLabel: '(20%-25%)',
                            porcentaje: resp.porcentaje,
                            numerador: resp.numerador,
                            denominador: resp.denominador,
                            color: this.colors[resp.centralAvisosPrioridadId - 1],
                            prioridad: resp.centralAvisosPrioridadId - 1
                        };

                        this.expedicionDesignados[4] = {
                            label: this._translate.instant('central-avisos.designaciones.expedicionDesignados.preLabel') + operador
                                    + this._translate.instant('central-avisos.designaciones.expedicionDesignados.postLabel'),
                            subLabel: '(20%-25%)',
                            descripcion: this._translate.instant('central-avisos.designaciones.expedicionDesignados.descripcion2025'),
                            labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                            dataList: [resp.porcentaje, (100 - resp.porcentaje).toFixed(2), resp.numerador + '/' + resp.denominador],
                            colors: this.colors[resp.centralAvisosPrioridadId - 1]
                        };
                    } else if (operador === '>' && !porcentajes.max) {
                        this.datosExpedicionDesignados[5] = {
                            descripcion: this._translate.instant('central-avisos.designaciones.expedicionDesignados.descripcionMas25'),
                            label: this._translate.instant('central-avisos.designaciones.expedicionDesignados.preLabel') + operador
                                    + this._translate.instant('central-avisos.designaciones.expedicionDesignados.postLabel'),
                            subLabel: '(>25%)',
                            porcentaje: resp.porcentaje,
                            numerador: resp.numerador,
                            denominador: resp.denominador,
                            color: this.colors[resp.centralAvisosPrioridadId - 1],
                            prioridad: resp.centralAvisosPrioridadId - 1
                        };

                        this.expedicionDesignados[5] = {
                            label: this._translate.instant('central-avisos.designaciones.expedicionDesignados.preLabel') + operador
                                    + this._translate.instant('central-avisos.designaciones.expedicionDesignados.postLabel'),
                            subLabel: '(>25%)',
                            descripcion: this._translate.instant('central-avisos.designaciones.expedicionDesignados.descripcionMas25'),
                            labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                            dataList: [resp.porcentaje, (100 - resp.porcentaje).toFixed(2), resp.numerador + '/' + resp.denominador],
                            colors: this.colors[resp.centralAvisosPrioridadId - 1]
                        };
                    }
                }
                setTimeout(resolve, 1);
            }, (error) => {
              setTimeout(resolve, 1);
            });
        });
    }

    public getKgDesignadosRespectoAforo(porcentajes, operador): Promise<any> {
        return new Promise((resolve, reject) => {
            let filters;
            filters = {
                porcentajeMin: porcentajes.min ? porcentajes.min : null,
                porcentajeMax: porcentajes.max ? porcentajes.max : null
            };

            this._spinnerService.showSpinner();
            if (this.toCloseSpinner === 0) {
                this.toCloseSpinner += 1;
            }
            this._dataService.getKilosDesignadosRespectoAforoDesignaciones(filters).toPromise().finally(() => {
                this.checkCloseSpinner();
                this.numAvisos.emit(1);
            }).then((resp) => {
                if (resp) {
                    if (operador === '<' && !porcentajes.min) {
                        this.datosDesignadosAforo[0] = {
                            descripcion: this._translate.instant('central-avisos.designaciones.designadosAforo.descripcionMenos90'),
                            label: this._translate.instant('central-avisos.designaciones.designadosAforo.preLabel') +
                                    operador + this._translate.instant('central-avisos.designaciones.designadosAforo.postLabel'),
                            subLabel: '(<90%)',
                            porcentaje: resp.porcentaje,
                            numerador: resp.numerador,
                            denominador: resp.denominador,
                            color: this.colors[resp.centralAvisosPrioridadId - 1],
                            prioridad: resp.centralAvisosPrioridadId - 1
                        };

                        this.designadosAforo[0] = {
                            label: this._translate.instant('central-avisos.designaciones.designadosAforo.preLabel') +
                                    operador + this._translate.instant('central-avisos.designaciones.designadosAforo.postLabel'),
                            subLabel: '(<90%)',
                            descripcion: this._translate.instant('central-avisos.designaciones.designadosAforo.descripcionMenos90'),
                            labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                            dataList: [resp.porcentaje, (100 - resp.porcentaje).toFixed(2), resp.numerador + '/' + resp.denominador],
                            colors: this.colors[resp.centralAvisosPrioridadId - 1]
                        };
                    } else if (operador === '<' && porcentajes.max) {
                        this.datosDesignadosAforo[1] = {
                            descripcion: this._translate.instant('central-avisos.designaciones.designadosAforo.descripcion9099'),
                            label: this._translate.instant('central-avisos.designaciones.designadosAforo.preLabel') +
                                    operador + this._translate.instant('central-avisos.designaciones.designadosAforo.postLabel'),
                            subLabel: '(90%-99%)',
                            porcentaje: resp.porcentaje,
                            numerador: resp.numerador,
                            denominador: resp.denominador,
                            color: this.colors[resp.centralAvisosPrioridadId - 1],
                            prioridad: resp.centralAvisosPrioridadId - 1
                        };

                        this.designadosAforo[1] = {
                            label: this._translate.instant('central-avisos.designaciones.designadosAforo.preLabel') +
                                    operador + this._translate.instant('central-avisos.designaciones.designadosAforo.postLabel'),
                            subLabel: '(90%-99%)',
                            descripcion: this._translate.instant('central-avisos.designaciones.designadosAforo.descripcion9099'),
                            labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                            dataList: [resp.porcentaje, (100 - resp.porcentaje).toFixed(2), resp.numerador + '/' + resp.denominador],
                            colors: this.colors[resp.centralAvisosPrioridadId - 1]
                        };
                    } else if (operador === '>' && porcentajes.max === 110) {
                        this.datosDesignadosAforo[2] = {
                            descripcion: this._translate.instant('central-avisos.designaciones.designadosAforo.descripcio110'),
                            label: this._translate.instant('central-avisos.designaciones.designadosAforo.preLabel') +
                                    operador + this._translate.instant('central-avisos.designaciones.designadosAforo.postLabel'),
                            subLabel: '(1%-10%)',
                            porcentaje: resp.porcentaje,
                            numerador: resp.numerador,
                            denominador: resp.denominador,
                            color: this.colors[resp.centralAvisosPrioridadId - 1],
                            prioridad: resp.centralAvisosPrioridadId - 1
                        };

                        this.designadosAforo[2] = {
                            label: this._translate.instant('central-avisos.designaciones.designadosAforo.preLabel') +
                                    operador + this._translate.instant('central-avisos.designaciones.designadosAforo.postLabel'),
                            subLabel: '(1%-10%)',
                            descripcion: this._translate.instant('central-avisos.designaciones.designadosAforo.descripcion110'),
                            labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                            dataList: [resp.porcentaje, (100 - resp.porcentaje).toFixed(2), resp.numerador + '/' + resp.denominador],
                            colors: this.colors[resp.centralAvisosPrioridadId - 1]
                        };
                    } else if (operador === '>' && !porcentajes.max) {
                        this.datosDesignadosAforo[3] = {
                            descripcion: this._translate.instant('central-avisos.designaciones.designadosAforo.descripcionMas10'),
                            label: this._translate.instant('central-avisos.designaciones.designadosAforo.preLabel') +
                                    operador + this._translate.instant('central-avisos.designaciones.designadosAforo.postLabel'),
                            subLabel: '(>10%)',
                            porcentaje: resp.porcentaje,
                            numerador: resp.numerador,
                            denominador: resp.denominador,
                            color: this.colors[resp.centralAvisosPrioridadId - 1],
                            prioridad: resp.centralAvisosPrioridadId - 1
                        };

                        this.designadosAforo[3] = {
                            label: this._translate.instant('central-avisos.designaciones.designadosAforo.preLabel') +
                                    operador + this._translate.instant('central-avisos.designaciones.designadosAforo.postLabel'),
                            subLabel: '(>10%)',
                            descripcion: this._translate.instant('central-avisos.designaciones.designadosAforo.descripcionMas10'),
                            labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                            dataList: [resp.porcentaje, (100 - resp.porcentaje).toFixed(2), resp.numerador + '/' + resp.denominador],
                            colors: this.colors[resp.centralAvisosPrioridadId - 1]
                        };
                    }
                }
                setTimeout(resolve, 1);
            }, (error) => {
              setTimeout(resolve, 1);
            });
        });
    }

    public getDesignacionesDeshabilitadas(): Promise<any> {
        return new Promise((resolve, reject) => {
            let filters = {
                inpresionAutorizada: true
            };
            this._spinnerService.showSpinner();
            if (this.toCloseSpinner === 0) {
                this.toCloseSpinner += 1;
            }
            this._dataService.getDesignacionesDeshabilitadas(filters).toPromise().finally(() => {
                this.checkCloseSpinner();
                this.numAvisos.emit(1);
            }).then((resp) => {
                if (resp) {
                    this.datosDesignacionesDeshabilitadas[0] = {
                        descripcion: this._translate.instant('central-avisos.designaciones.designacionesDeshabilitadas.descripcion'),
                        porcentaje: resp.porcentaje,
                        numerador: resp.numerador,
                        denominador: resp.denominador,
                        color: this.colors[resp.centralAvisosPrioridadId - 1],
                        prioridad: resp.centralAvisosPrioridadId - 1
                    };

                    this.designacionesDeshabilitadas[0] = {
                        label: this._translate.instant('central-avisos.designaciones.designacionesDeshabilitadas.label'),
                        subLabel: '',
                        descripcion: this._translate.instant('central-avisos.designaciones.designacionesDeshabilitadas.descripcion'),
                        labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                        dataList: [resp.porcentaje, (100 - resp.porcentaje).toFixed(2), resp.numerador + '/' + resp.denominador],
                        colors: this.colors[resp.centralAvisosPrioridadId - 1]
                    };
                }
                setTimeout(resolve, 1);
            }, (error) => {
              setTimeout(resolve, 1);
            });
        });
    }

    public getDesignacionesFinalizadas(): Promise<any> {
        return new Promise((resolve, reject) => {
            let filters = {
                finalizada: true
            };
            this._spinnerService.showSpinner();
            if (this.toCloseSpinner === 0) {
                this.toCloseSpinner += 1;
            }
            this._dataService.getDesignacionesFinalizadas(filters).toPromise().finally(() => {
                this.checkCloseSpinner();
                this.numAvisos.emit(1);
            }).then((resp) => {
                if (resp) {
                    this.datosDesignacionesFinalizadas[0] = {
                        descripcion: this._translate.instant('central-avisos.designaciones.designacionesFinalizadas.descripcion'),
                        porcentaje: resp.porcentaje,
                        numerador: resp.numerador,
                        denominador: resp.denominador,
                        color: this.colors[resp.centralAvisosPrioridadId - 1],
                        prioridad: resp.centralAvisosPrioridadId - 1
                    };

                    this.designacionesFinalizadas[0] = {
                        label: this._translate.instant('central-avisos.designaciones.designacionesFinalizadas.label'),
                        subLabel: '',
                        descripcion: this._translate.instant('central-avisos.designaciones.designacionesFinalizadas.descripcion'),
                        labelList: [this._translate.instant('central-avisos.cumplenCondicion'), this._translate.instant('central-avisos.noCumplenCondicion')],
                        dataList: [resp.porcentaje, (100 - resp.porcentaje).toFixed(2), resp.numerador + '/' + resp.denominador],
                        colors: this.colors[resp.centralAvisosPrioridadId - 1]
                    };
                }
                setTimeout(resolve, 1);
            }, (error) => {
              setTimeout(resolve, 1);
            });
        });
    }

    private checkCloseSpinner() {
        if (this.toCloseSpinner === 1) {
            this.toCloseSpinner -= 1;
        }
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }

    private agruparInfo() {
        for (let expecicionCero of this.expedicionCero) {
            this.allDonuts.push(expecicionCero);
        }

        for (let expedicion of this.expedicionDesignados) {
            this.allDonuts.push(expedicion);
        }

        for (let designado of this.designadosAforo) {
            this.allDonuts.push(designado);
        }

        for (let deshabilitada of this.designacionesDeshabilitadas) {
            this.allDonuts.push(deshabilitada);
        }

        for (let finalizada of this.designacionesFinalizadas) {
            this.allDonuts.push(finalizada);
        }
    }

    public showGrid(donut) {
        this.tituloGrid = donut.label + ' ' + donut.subLabel;
        this.gridModal = true;
    }

    public refresh(value) {
        this.gridModal = false;
    }

    public getDataExpedicionCero(data) {
        if (data) {
            this.dataExpedicionCero = data;
        }
    }
}
